<template>
  <list-items :suppress="0" :external-type="integrationsTypes.sportradar" />
</template>

<script>
import ListItems from '@/modules/audiences/pages/BaseListItems'
import { integrationsTypes } from '@/modules/integrations/enum/IntegrationsEnum'

export default {
  data() {
    return { integrationsTypes }
  },
  components: { ListItems }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/pages/SportradarListItems.vue